import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildings1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "buildings-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3,
			y1: 14.25,
			x2: 7.5,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3,
			y1: 17.25,
			x2: 7.5,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3,
			y1: 20.25,
			x2: 7.5,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3,
			y1: 8.25,
			x2: 7.5,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3,
			y1: 11.25,
			x2: 7.5,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.75,
			y1: 14.25,
			x2: 20.25,
			y2: 14.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.75,
			y1: 17.25,
			x2: 20.25,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.75,
			y1: 20.25,
			x2: 20.25,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18.75,
			y1: 11.25,
			x2: 20.25,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.25,3.75h8a.5.5,0,0,1,.5.5v19a0,0,0,0,1,0,0H1.25a.5.5,0,0,1-.5-.5V4.25A.5.5,0,0,1,1.25,3.75Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 9.75,
			y: 12.75,
			width: 6,
			height: 10.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.25,6.75h6.5a.5.5,0,0,1,.5.5v15.5a.5.5,0,0,1-.5.5h-7a0,0,0,0,1,0,0v-16A.5.5,0,0,1,16.25,6.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: .75,
			x2: 3.75,
			y2: 3.75
		})
	]
});
export default SvgBuildings1;
